<template>
  <v-container>
    <TitleWidget>Depoimentos</TitleWidget>
    <div class="text-center">Veja o que nossos clientes dizem</div>
    <div class="overflow-hidden">
      <!-- Elfsight Google Reviews | Precisa Automação -->
      <div
        class="elfsight-app-833dd28b-a7aa-4306-965a-5945914fda52 my-10"
        data-elfsight-app-lazy
      ></div>
    </div>
  </v-container>
</template>

<script>
import TitleWidget from "../widgets/TitleWidget.vue";

export default {
  components: {
    TitleWidget,
  },
};
</script>
